module.exports = __webpack_public_path__ + "static/media/logo.238ab7aa.svg";